@if (!isReadonly) {
  <button
    (click)="copyToken()"
    [matTooltip]="tokenTooltip"
    >
    Copy Token
  </button>
}

<div class="info">
  @if (testingRole | async) {
    <label>Testing Role:</label>
  }
  @if (testingRole | async) {
    <strong>{{ testingRole.value }}</strong>
  }

  <label>User Roles:</label>
  <strong>{{ userRoles }}</strong>

  <label>API Version:</label>
  <strong>
    <a [attr.href]="releaseNotesUrl" target="_blank">{{ appVersion }}</a>
  </strong>

  <label>UI Version:</label>
  <strong>
    <a [attr.href]="menuUiUrl" target="_blank">{{ uiVersion }}</a>
  </strong>

  <label>DB Version:</label>
  <strong>{{ dbVersion }}</strong>

  <label>Environment:</label>
  <strong>{{ environment }}</strong>

  <label>Built:</label>
  <strong>{{ buildTime }}</strong>

  <label>Commit:</label>
  <strong>
    <a
      [attr.href]="'https://github.com/cfacorp/menu-api/commit/' + commit"
      [matTooltip]="commitToolTip"
      target="_blank"
      >
      {{ commit }}
    </a>
  </strong>
</div>
